export default __webpack_public_path__ + "static/media/tete56.b5f32779.png";